<template>
  <div class="request-home">
    <div class="video-container">
      <video id="video" autoplay loop muted>
        <source src="/dist/video/01_about.mp4" type="video/mp4">
        배경화면
      </video>
    </div>
    <div class="welcome-header"></div>
    <div class="welcome" style="z-index:2">
      <div class="box">
        <div class="box-content">
          <div class="ncp-logo">
          </div>
          <p class="welcome-title1">수기입실</p>
          <br/>
          <br/>
          <p>
            QR 코드 미지참 시, 방문 신청 정보를 조회하여 출입 합니다.
          </p>
          <br/>
          <br/>
          <div class="box-row">
            <div class="box-label">이름</div>
            <input type="text" class="box-input" v-model="item.name"/>
          </div>
          <div class="box-row">
            <div class="box-label">이메일</div>
            <input type="text" class="box-input" v-model="item.email" @keyup.enter="getAuth()"/>
          </div>
        </div>
        <div class="box-bottom" >
          <div class="lang"><i class="icon-global"></i></div>
          <a class="btn lg white point" @click="getReserveList()">확인</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import Vuex from 'vuex';

Vue.use(Vuex);
export default {
  name: "Request",
  components: {
  },
  data(){
    return {
      item: {
        name : null,
        email : null
      },
      isShow: true
    }
  },
  mounted(){
    this.isShow = true;

  },
  methods: {
    getReserveList(){

      if(!this.item.name || !this.item.email){
        // this.$toast.error(this.$t('이름, 이메일 정보를 입력해주세요'));
        this.noti('입력 정보 확인', '이름, 이메일 정보를 입력해주세요.', 'danger');
        return;
      }

      // this.goManualEnter(null)

      var o = {visitorEmail: this.item.email, visitorName: this.item.name}
      var payloadString = $.param(o);
      var that = this;
      this.$http.get('/api/private/visitor/menualEnter'+'?'+ payloadString)
        .then((result) => {
          if(result.data.length == 0) {
            // that.$toast.error('예약 정보를 찾을 수 없습니다. </br></br> 1. 입력 정보 오타 확인 </br> 2. 예약 완료 여부 확인');
            this.noti('예약 정보를 찾을 수 없습니다.', '1. 입력 정보 오타 확인 </br> 2. 예약 완료 여부 확인 </br> (담당 직원 출입위치 미지정 또는 출입 기안 완료 여부를 확인해주세요.)', 'danger');
            return ;
          }
          this.item.name = null;
          this.item.email = null;
          this.goManualEnter(result.data);
        }).catch((e) =>{
          console.log(e)
          this.noti('오류', e, 'danger');
          // that.$toast.error(that.$t('error.visitError'));
      })
    },
    goManualEnter(data){
      var uuid = "3ffb420f-4cba-4c11-a868-91de2ad931c4";
      var steps =  [
        {id: 1, name: this.$t('label.enterTicket'), routeName : 'selectIdc', isSelect: 'on', component: 'SelectTicket'},
        {id: 2, name: this.$t('label.secAgree'), routeName : 'agree', isSelect: '', component: 'Agree'},
        {id: 3, name: this.$t('label.inOutCheckList'), routeName : 'inputInfo', isSelect: '', component: 'InOutCheckList'},
        {id: 4, name: this.$t('label.enterInfo'), routeName : 'checkInfo', isSelect: '', component: 'EnterInfo'},
      ]
      this.openModal({view: 'modal/TosCheck', side: false, mode: 'new' , title: '입실 정보 입력', data: {steps: steps, data:data, reserve:data}, showBottom: false})
    }


  }
};
</script>
